const capitalize = (text: string) =>
  text ? text.charAt(0).toUpperCase() + text.slice(1) : ''

const splitByUppercase = (input: string): string => {
  if (!input) return ''

  let result = ''
  let current = ''

  for (let i = 0; i < input.length; i++) {
    const char = input[i]
    const code = char.charCodeAt(0)

    const isUppercase = code >= 65 && code <= 90
    const nextChar = input[i + 1]
    const nextIsUppercase =
      nextChar && nextChar.charCodeAt(0) >= 65 && nextChar.charCodeAt(0) <= 90

    if (isUppercase) {
      if (
        current &&
        current[current.length - 1].toUpperCase() !==
          current[current.length - 1]
      ) {
        result += `${current} `
        current = char
      } else {
        current += char
      }
    } else {
      if (
        current.length > 1 &&
        current[current.length - 1] ===
          current[current.length - 1].toUpperCase()
      ) {
        result += `${current} `
        current = char
      } else {
        current += char
      }
    }

    if (isUppercase && !nextIsUppercase && current.length > 1) {
      result += `${current.slice(0, -1)} `
      current = current[current.length - 1]
    }
  }

  if (current) result += current

  return result
}

const normalize = (str: string) =>
  typeof str === 'string' ? str.toLowerCase().replaceAll(' ', '-') : str

export { capitalize, splitByUppercase, normalize }
